import { getCurrentOrganizationId } from './organizationSelectors';

export const getState = state => state.newBucketPage;

export const getBucketName = state => state.newBucketPage.bucketName;
export const getBucketDescription = state =>
    state.newBucketPage.bucketDescription;
export const getError = state => state.newBucketPage.error;
export const getLoading = state => state.newBucketPage.loading;

export const getVisibleInApplications = (
    state,
    organizationId = getCurrentOrganizationId(state),
) => {
    const organization = state.db.organizations[organizationId];
    if (!organization) {
        return undefined;
    }
    const visibleApps = organization.visibleInApplications.map(
        appId => state.db.applications[appId].id,
    );
    
    // Always include the 'all' application
    if (!visibleApps.includes('all')) {
        visibleApps.unshift('all');
    }
    
    return visibleApps;
};

export const getVisibleInApplicationsWithoutAll = (state, organizationId) =>
    getVisibleInApplications(state, organizationId).filter(str => str !== 'all');

export const getIsFormValid = state => {
    const { bucketName } = getState(state);
    return !!bucketName && bucketName.trim().length > 0;
};



// WEBPACK FOOTER //
// ./src/selectors/newBucketSelectors.js